<div class="card m-2 {{ field.props?.['hideField'] ? 'd-none' : '' }}">
  <p class="card-header d-flex justify-content-between" *ngIf="props">
    <span>
      {{ props.label }}
      <span
        class="badge bg-primary ms-1"
        *ngIf="field?.props?.['badgeText'] !== undefined">
        {{ field.props?.['badgeText'] }}
      </span>
    </span>
    <span>
      <i
        *ngIf="field?.props?.['collapsible']"
        class="fa fa-solid ms-3 text-primary {{
          collapsed ? 'fa-plus' : 'fa-minus'
        }} pointer-cursor"
        (click)="collapsed = !collapsed"></i>
    </span>
  </p>
  <div class="card-body" *ngIf="!collapsed">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
